<template>

   <div class=" px-6 py-8 rounded-lg bg-blue-imbt hover:bg-blue-hov hover:text-white">
      <p class="text-blue-textm hover:text-white text-base  "><span class="font-semibold text-2xl pb-4">Glass</span></p>
      
     
     <ul class="list-disc marker:text-blue-500 text-base text-blue-textm hover:text-white text-base pl-5">
        <LI>Glass partitions</LI>
        <li>Glass cutting</li>
        <li>Table top</li>
        
        <li>Shower enclosures</li>
        <li>Mirrors</li>
        <li>Window Vinyl Frosting</li>
        <li>Flush glazing</li>
     </ul>
       </div>

</template>
<script>
 export default {
     name: 'Glass',
 }
</script>